export default __webpack_public_path__ + "static/media/Kapci.1d04747f.png";